import {Component} from "./Component";
import {hasParent} from "../util/dom";
import {createLogger} from "../util/logger";

const console = createLogger("Services");

export class Services extends Component {
    static name = "services";

    get name() {
        return Services.name;
    }

    constructor(el) {
        super(el);

        /**
         * @type {boolean}
         */
        this.open = false;

        /**
         * @type {HTMLElement[]}
         */
        this.$cards = Array.from(this.el.querySelectorAll(".card"));

        /**
         * @type {HTMLElement}
         */
        this.$overlay = this.el.querySelector(".service-overlay");

        /**
         * @type {HTMLElement}
         */
        this.$overlayContent = this.$("overlayContent");

        this.$overlayContentContainer = this.$overlayContent.parentElement;

        /**
         * @type {HTMLElement}
         */
        this.$overlayButton = this.$("overlayButton");

        /**
         * @type {HTMLButtonElement}
         */
        this.$btnCloseOverlay = this.$("btnCloseOverlay");


        this.addEventListener(this.$cards, "click", this.onClickCard.bind(this));

        this.addEventListener(this.$overlay, "click", this.onClickOverlay.bind(this));

        this.addEventListener(this.$btnCloseOverlay, "click", this.onClickClose.bind(this));


        console.log(this);
    }

    /**
     * @param {MouseEvent} e
     */
    onClickClose(e) {
        e.stopPropagation();

        this.hideOverlay();
    }

    /**
     * @param {MouseEvent} e
     */
    onClickRequestService(e) {
        this.hideOverlay();

        const select = document.getElementById("serviceType");

        console.log("select", select);

        window.scrollTo({
            top: select.getBoundingClientRect().top + window.scrollY - 420,
            behavior: "smooth",
        });

        if (this.$btnRequestService) {
            select.value = this.$btnRequestService.getAttribute("data-service-name");
        }
        // document.getElementById("message").focus();
    }

    /**
     * @param {MouseEvent} e
     */
    onClickOverlay(e) {
        console.log("onClickOverlay", this.open);
        if (!this.open) return;

        if (hasParent(e.target, this.$overlayContentContainer)) return;


        this.hideOverlay();
    }

    /**
     * @param {MouseEvent} e
     */
    onClickCard(e) {
        console.log("onClickCard");
        e.preventDefault();

        const $card = e.currentTarget;
        const $content = $card.querySelector(".service-content");

        console.log("onClickCard", this.$overlayContent, $content.innerHTML);

        this.$overlayContent.innerHTML = $content.innerHTML;

        const $button = $card.querySelector(".service-button");
        this.$overlayButton.innerHTML = $button.innerHTML;

        const name = $card.getAttribute("data-service-name");

        this.$btnRequestService = this.$overlayContentContainer.querySelector(this.getAttributeSelector("btnRequestService"));
        if (this.$btnRequestService) {
            this.addEventListener(this.$btnRequestService, "click", this.onClickRequestService.bind(this));
        }

        this.showOverlay();
    }

    showOverlay() {
        console.log("showOverlay");
        this.open = true;
        document.body.classList.add("service-overlay--visible");
    }

    hideOverlay() {
        console.log("hideOverlay");
        this.open = false;
        document.body.classList.remove("service-overlay--visible");

        if (this.$btnRequestService) {
            this.removeEventListener(this.$btnRequestService, "click", this.onClickRequestService.bind(this));
        }
    }
}
